import type { StatusPost200Response } from '../@types/native-api/generated/gino';
import type { EcardEnv, EcardIpcResponse } from '../@types/nativeApi';

export const buildErrorDetails = (response: EcardIpcResponse<unknown>): string => {
  let errorDetails = '';
  if (response.error) {
    errorDetails += `Details: ${response.error.text}`;
  }
  if (response.error?.code) {
    errorDetails += `, Code: ${response.error.code}`;
  }
  if (response.error?.detailCode) {
    errorDetails += `, Detailcode: ${response.error.detailCode}`;
  }
  return errorDetails;
};

export const getCardSlot = (response: EcardIpcResponse<StatusPost200Response>, type: 'e-card' | 'o-card') => {
  let slot;
  if (response.data?.status?.baseContact?.registered === type) {
    slot = response.data?.status?.baseContact;
  } else if (response.data?.status?.baseNfc?.registered === type) {
    slot = response.data?.status?.baseNfc;
  } else if (response.data?.status?.satellite?.registered === type) {
    slot = response.data?.status?.satellite;
  }
  return slot;
};

export const ecardEnv = (): EcardEnv => (window._env_.ENV_TAG === 'prod' ? 'prod' : 'test');
